<template>
  <div class="content-container">
    <!-- <div class="cc-coll-header">
        <span class="cc-coll-title">添加账号</span>
    </div>-->
    <ContentBox :title="mode === 'edit'? '编辑协作账号':'新建协作账号' " class="content-box">
      <el-form
        class="demo-ruleForm"
        ref="addForm"
        :model="addForm"
        :rules="rules"
        label-position="left"
        label-width="120px"
        hide-required-asterisk
      >
        <el-form-item label="登录账号" prop="agentAccount">
          <el-input v-noEmoji v-model="addForm.agentAccount" placeholder="8-20个英文字符、数字" maxlength="45" />
        </el-form-item>
        <el-form-item label="登录密码" prop="loginPwd">
          <div v-if="showPwdText">
            <span>********</span>
            <span class="el-icon-edit" style="padding-left: 20px;color:#ff8b00;cursor:pointer" title="修改密码" @click="showPwdText = false"></span>
          </div>
          <el-input
            v-else
            v-model="addForm.loginPwd"
            v-noEmoji
            type="password"
            autocomplete="new-password"
            placeholder="必须包含数字、字母及特殊符号，长度不少于8位"
            maxlength="60"
          />
        </el-form-item>
        <el-form-item v-if="!showPwdText" label="确认密码" prop="confirmLoginPwd">
          <el-input
            v-noEmoji type="password"
            v-model="addForm.confirmLoginPwd"
            autocomplete="new-password"
            placeholder="请再次输入登录密码"
            maxlength="45"
          />
        </el-form-item>
        <el-form-item label="账号名称" prop="agentAccountName">
          <el-input v-noEmoji v-model="addForm.agentAccountName" placeholder="3-20个字符" maxlength="45" />
        </el-form-item>
          <el-form-item label="手机号" prop="phone">
          <el-input v-noEmoji v-model="addForm.phone" maxlength="11"  placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item  prop="email">
          <span slot="label">
            <span>邮件地址</span>
            <span style="color:rgba(0,0,0,0.65);padding:0 5px;">(选填)</span>
          </span>
          <el-input v-noEmoji v-model="addForm.email"  placeholder="请输入邮箱地址" />
        </el-form-item>
        <el-form-item label="账号角色" prop="flag">
          <el-radio-group v-model="addForm.flag" @change="handleChangeFlag">
            <!-- <el-radio :label="0">管理员</el-radio> -->
            <el-radio :label="1" v-show="!this.$service.state.isTopPartner">操作员</el-radio>
            <el-radio :label="3">数据员</el-radio>
             <el-radio :label="4" v-show="!this.$service.state.isTopPartner">财务</el-radio>
            <el-radio :label="2" v-show="!this.$service.state.isTopPartner">业务员</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="操作客户" prop="adPartnerIdList" class="cc-coll-body-user" v-if="addForm.flag !== 4">
          <el-transfer
            style="text-align: left; display: inline-block"
            v-model="addForm.adPartnerIdList"
            filterable
            :titles="['客户名称', '已选']"
            :props="{
                key: 'partnerId',
                label: 'partnerName'
              }"
            :data="userData"
          >
          </el-transfer>
        </el-form-item>
        <el-form-item label="状态" prop="disabled">
          <el-radio-group v-model="addForm.disabled">
            <el-radio :label="0">启用</el-radio>
            <el-radio :label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </ContentBox>
    <ContentBox>
      <el-button @click="handleQuit">
        <i class="icon-ios-undo"></i>取消
      </el-button>
      <el-button type="primary" @click="handleSave('addForm')" :loading="loading">
        <i class="icon-ios-compose"></i>保存
      </el-button>
    </ContentBox>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
export default {
  props: ['mode', 'id'],
  data() {
    var validateConfirmLoginPwd = (rule, value, callback) => {
      if (!this.showPwdText && !value) {
        callback(new Error('请再次输入登录密码'))
      } else if (value !== this.addForm.loginPwd) {
        callback(new Error('请确认两次输入密码一致'))
      } else {
        callback()
      }
    }
    var validateUserAccount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写登录账号'))
      } else {
        if (value === this.oldForm.agentAccount) {
          callback()
        } else {
          if (/^[A-Za-z]+$/g.test(value)) {
            this.$service.checkAccount({ agentAccount: this.$encrypt(value) }).then(data => {
              if (data.isError) {
                callback(new Error('该登录账号已被使用，请重新输入'))
              } else {
                callback()
              }
            })
          } else {
            if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(value)) {
              this.$service.checkAccount({ agentAccount: this.$encrypt(value) }).then(data => {
                if (data.isError) {
                  callback(new Error('该登录账号已被使用，请重新输入'))
                } else {
                  callback()
                }
              })
            } else {
              callback(new Error('登录账号为8-20个字符，需为英文字母、数字的组合'))
            }
          }
        }
      }
    }
    var validatePwd = (rule, value, callback) => {
      if (!this.showPwdText && !value) {
        callback(new Error('请填写登录密码'))
      } else {
        if (value === this.oldForm.loginPwd) {
          callback()
        } else {
          if (/^(?![A-Za-z0-9]+$)(?![A-Za-z\W]+$)(?![0-9\W]+$)[a-zA-Z0-9\W]{8,}$/.test(value)) {
            if (value === this.addForm.agentAccount) {
              callback(new Error('密码不能与登录账号相同'))
            } else {
              callback()
            }
          } else {
            callback(new Error('必须包含数字、字母及特殊符号，长度不少于8位'))
          }
          callback()
        }
      }
    }
    var validateAccountName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写账号名称'))
      } else {
        if (/^[\u4E00-\u9FA5A-Za-z0-9]{3,20}$/.test(value)) {
          callback()
        } else {
          callback(new Error('账号名称为3-20个字符，不能包含特殊符号或空格'))
        }
      }
    }
    var validatorPhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写手机号'))
      } else {
        if (value === this.oldForm.phone) {
          callback()
        } else {
          const regx = /^1(3|4|5|7|8)\d{9}$/
          if (!regx.test(value)) {
            callback(new Error('请输入正确手机号'))
          } else {
            this.$service.checkPhone({ phone: this.$encrypt(value) }).then(data => {
              if (data.isError) {
                callback(new Error('手机号已被使用，请重新输入'))
              } else {
                callback()
              }
            })
          }
        }
      }
    }
    return {
      loading: false,
      addForm: {
        agentAccountId: undefined,
        agentAccount: '', // 登录账号
        loginPwd: undefined, // 登录密码
        confirmLoginPwd: undefined, // 确认密码
        agentAccountName: '', // 账号名称
        email: '', // 邮箱地址
        phone: '', // 手机号
        flag: 1, // 账号角色
        disabled: 0, // 状态
        adPartnerIdList: [] // 操作客户
      },
      rules: {
        agentAccount: [
          { required: true, validator: validateUserAccount, trigger: 'blur' }
        ],
        loginPwd: [
          { validator: validatePwd, trigger: 'blur' }
        ],
        confirmLoginPwd: [
          { validator: validateConfirmLoginPwd, trigger: 'blur' }
        ],
        agentAccountName: [
          { required: true, validator: validateAccountName, trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        phone: [{ required: true, validator: validatorPhone, trigger: 'blur' }],
        adPartnerIdList: [
          { type: 'array', required: true, message: '请至少选择一个操作客户', trigger: 'blur' }
        ]
      },
      userData: [],
      oldForm: {},
      showPwdText: false
    }
  },
  methods: {
    handleChangeFlag() {
      if (this.addForm.flag === 4) {
        this.addForm.adPartnerIdList = this.userData.map(item => { return item.partnerId })
      } else {
        this.addForm.adPartnerIdList = []
      }
    },
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const params = this.cloneDeep(this.addForm)
          if (params.flag === 4) {
            params.adPartnerIdList = this.userData.map(item => {
              return item.partnerId
            })
          }
          params.agentAccount = this.$encrypt(params.agentAccount)
          params.loginPwd = params.loginPwd ? this.$encrypt(params.loginPwd) : undefined
          params.confirmLoginPwd = params.confirmLoginPwd ? this.$encrypt(params.confirmLoginPwd) : undefined
          params.phone = params.phone ? this.$encrypt(params.phone) : ''
          params.email = params.email ? this.$encrypt(params.email) : ''
          this.loading = true
          if (this.mode === 'edit') {
            this.$service
              .accAdAgentAccountEdit(params, '操作成功')
              .then(data => {
                this.loading = false
                this.$emit('go-back', true)
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            this.$service
              .accAdAgentAccountAdd(params, '操作成功')
              .then(data => {
                this.loading = false
                this.$emit('go-back', true)
              })
              .catch(() => {
                this.loading = false
              })
          }
        }
      })
    },
    handleQuit() {
      const isChange = this.$consts.difference(this.oldForm, this.addForm)
      if (Object.keys(isChange).length > 0) {
        this.$confirm('页面内容未保存，确定要离开吗？', '提示', {
          confirmButtonText: '离开页面',
          cancelButtonText: '留在页面',
          center: true,
          type: 'warning'
        })
          .then(() => {
            this.$emit('go-back')
          }).catch(() => {
          })
      } else {
        this.$emit('go-back', false)
      }
    },
    getAccAdAgentAccountDataList() {
      this.$service
        .getAccAdAgentAccountDataList({})
        .then(data => {
          this.userData = data
        })
        .catch(() => {
        })
    },
    getAccAdAgentAccountDetail() {
      this.$service
        .getAccAdAgentAccountDetail({ agentAccountId: this.id })
        .then(data => {
          this.addForm.agentAccountId = data.agentAccountId
          this.addForm.agentAccount = this.$decrypt(data.agentAccount)
          this.addForm.agentAccountName = data.agentAccountName
          this.addForm.email = this.$decrypt(data.email)
          this.addForm.phone = this.$decrypt(data.phone)
          this.addForm.flag = data.flag
          this.addForm.disabled = data.disabled
          this.addForm.adPartnerIdList = data.adDspPartnerEntityList.map(item => {
            return item.adAccountInfoEntity.partnerId
          })
          this.oldForm = JSON.parse(JSON.stringify(this.addForm))
          this.showPwdText = true
        })
        .catch(() => {
        })
    }
  },
  created() {
    if (this.mode === 'edit') {
      this.getAccAdAgentAccountDetail()
    } else {
      this.addForm.flag = this.$service.state.isTopPartner ? 3 : 1
    }
    this.getAccAdAgentAccountDataList()
    this.oldForm = JSON.parse(JSON.stringify(this.addForm))
  }
}
</script>
<style lang="stylus" scoped>
.content-container {
  margin: 16px;
}

>>>.title {
  padding-left: 32px;
}

>>>.content-box__main {
  margin-left: 32px;
}

.demo-ruleForm {
  width: 584px;
}

>>>.el-transfer__buttons {
  padding: 0 10px;
}

>>>.el-transfer__buttons button {
  width: 35px;
  padding: 5px;
}

>>>.el-transfer-panel {
  width: 182px;
}
</style>
